// extracted by mini-css-extract-plugin
module.exports = {"pcWrap":"pcWrap___3vLHY","mobileWrap":"mobileWrap___JgPCL"};